export default {
  edit: {
    title: 'تعديل الملف الشخصي',
    subTitle: 'نموذج التعديل',
    editButton: 'تعديل'
  },
  generalInformations: 'المعلومات العامة',
  myProfile: 'ملفي الشخصي',
  myInformations: 'معلوماتي',
  caregivers: 'مساعدي',
  changePassword: 'تغيير كلمة المرور',
  notifications: {
    label: 'إدارة الإخطارات',
    disable: 'أريد تعطيل جميع الإشعارات',
    dailySynthesis: {
      enable: 'أريد ملخصًا يوميًا',
      label: 'التوليف اليومي',
      description1: 'سيتم إرسال ملخص يومي إليك كل صباح.',
      description2: 'يحتوي هذا الملخص على جميع المعلومات المهمة لهذا اليوم:',
      newDocuments: 'وثائق جديدة',
      newMessages: 'رسائل جديدة',
      newTherapeuticContents: 'محتويات علاجية جديدة',
      surveys: 'الاستطلاعات',
      calendarEvents: 'المواعيد/التذكيرات'
    },
    individualNotifications: {
      label: 'الإخطارات الفردية',
      enable: 'أريد إدارة إشعاراتي بشكل فردي'
    }
  },
  iot: 'الأجهزة المتصلة',
  chooseLanguage: 'اختيار اللغة',
  timezone: {
    label: 'المنطقة الزمنية',
    select: 'تحديد المنطقة الزمنية',
    search: 'البحث عن منطقة زمنية',
    auto: 'أوتوماتيكي ({timezone})',
    name: '({offset}) {name}',
    current: 'المنطقة الزمنية الحالية:',
    new: 'منطقة زمنية جديدة:',
    updateSuccess: 'تم تحديث منطقتك الزمنية. سيتم تحديث الصفحة',
    updateError: 'غير قادر على تحديث منطقتك الزمنية'
  },
  help: 'التوثيق والمساعدة',
  onlineHelp: 'مساعدة عبر الإنترنت',
  userManual: 'دليل المستخدم',
  legalMentions: 'الشروط القانونية',
  eula: 'اتفاقية المستخدم النهائية',
  about: 'عن التطبيق',
  disconnect: 'تسجيل الخروج',
  menu: 'الرجوع إلى القائمة',
  password: 'كلمة المرور',
  editProfile: {
    title: 'تعديل ملفي الشخصي',
    emailAddress: 'عنوان البريد الإلكتروني',
    addAddress: 'إضافة عنوان بريد إلكتروني',
    phone: 'الهاتف',
    addPhone: 'إضافة رقم هاتف',
    phoneNumber: 'رقم الهاتف'
  },
  endUserLevelAgreement: 'شروط الاستخدام',
  otp: {
    invalidCode: 'الرمز غير صالح'
  },
  emailUpdate: {
    info: 'يمكنك تحديد عنوان بريد إلكتروني جديد لحسابك.',
    validationCode: 'لتأكيد أن هذا العنوان، سنرسل لك رمز التحقق من صحة العنوان.',
    waitBeforeRetry: 'الرجاء الانتظار {duration} قبل إعادة المحاولة',
    sentValidationCode: 'لتأكيد أن هذا العنوان, هو عنوانك بالفعل، لقد قمنا بإرسال رمز التحقق إلى عنوانك الإلكتروني الجديد.',
    verifyCode: 'التحقق من الرمز',
    success: 'تم تحديث عنوان البريد الإلكتروني بنجاح',
    error: {
      alreadyUsedEmailAddress: 'لقد تم استخدام هذا العنوان الإلكتروني مسبقًا'
    }
  },
  mobilePhoneUpdate: {
    info: 'يمكنك تحديد رقم هاتف جديد لحسابك.',
    validationCode: 'لتأكيد أن هذا الرقم هو رقمك بالفعل، سنرسل لك رمز التحقق عبر الرسائل النصية.',
    waitBeforeRetry: 'الرجاء الانتظار {duration} قبل إعادة المحاولة',
    sentValidationCode: 'لتأكيد أن هذا الرقم هو رقمك بالفعل، قمنا بإرسال رمز التحقق إلى رقمك الجديد.',
    verifyCode: 'التحقق من الرمز',
    success: 'تم تحديث رقم الهاتف بنجاح'
  }
}
